import countriesData from '@/assets/data/countries.json';
export default {
  name: 'CountriesSelect',
  props: {
    value: {
      type: String
    },
    options: {
      type: Array,
      default: () => []
    },
    state: {
      type: Boolean,
      default: null
    },
    errorMessage: {
      type: String
    },
    disabled: {
      type: Boolean,
      default: false
    },
    placeholder: {
      type: String,
      default: ''
    },
    clearable: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    country: {
      get: function () {
        return this.value || '';
      },
      set: function (v) {
        this.$emit('input', v);
      }
    },
    defaultPlaceholder() {
      return this.$t('form.country.label');
    },
    allCountriesOptions() {
      const countries = [];
      for (let i = 0; i < countriesData.length; i++) {
        let c = countriesData[i];
        countries[i] = {
          label: c[0],
          value: c[1],
          itemClass: 'iti__' + c[1]
        };
      }
      return countries;
    },
    countriesOptions() {
      return this.options.length > 0 ? this.options : this.allCountriesOptions;
    },
    selectedCountryClass() {
      return this.country ? `iti__${this.country}` : 'iti__empty';
    }
  },
  methods: {
    changeCountry() {
      this.country = this.inputInstance.getSelectedCountryData().name;
    }
  }
};